import getCommonParams from '@/lib/request/getCommonParams';
import config from '@/config/index';
import { COMMON_INFO } from '@/const/base';
import store from '@/store/index';
import { get } from 'lodash-es';
import { getTicket } from '@/utils/user';
const country = get(store, 'state.common.country', '');

export async function payOptions() {
  const { lang, lat, lng, cityId } = await getCommonParams();
  return {
    appversion: '99.99.99', // 版本号传给ibt固定值
    lang: lang === 'es-419' ? 'es-MX' : lang, // todo钱包内无
    location_cityid: cityId,
    product_id: 12,
    utc_offset: -480,
    terminal_id: COMMON_INFO.TERMINAL_ID,
    biz_type: 9,
    lat: lat,
    lng: lng,
    source: 'didiFood',
    token: getTicket(), //todo
    location_country: country,
    payHost: config.payApiBase,
    cashierHost: config.cashierApiBase,
  };
}
